<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" color="navbar" app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title"> Ruben Broekx </v-list-item-title>
          <v-list-item-subtitle> <i>My personal website</i> </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list nav>
        <v-list-item
          v-for="item in navbarlist"
          :key="item.title"
          :to="item.route"
          @click="title = item.title"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="appbar" elevation="5" app>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-app-bar>

    <v-main> <router-view /> </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
export default {
  data: () => ({
    drawer: null,
    title: "",
    navbarlist: [
      { title: "About Me", icon: "mdi-account", route: "/" },
      { title: "Projects", icon: "mdi-code-tags", route: "/projects" },
      { title: "Curriculum Vitae", icon: "mdi-file-account", route: "/cv" },
    ],
  }),
};
</script>